
export default function AboutSection() {
  const missions = [
    {
      icon: 'ri-heart-pulse-line',
      title: '個人の幸福感・充実感の向上',
      description: 'こころとからだの健康づくりを通じて、一人ひとりが自分らしく輝ける社会を目指します。',
    },
    {
      icon: 'ri-building-line',
      title: '社会全体でのウェルビーイング推進',
      description: '企業・地域・社会が一体となり、持続可能な幸福の循環を創出します。',
    },
    {
      icon: 'ri-bear-smile-line',
      title: '人とペットの共生社会実現',
      description: 'ペットとの暮らしを通じて、癒しと健康、社会的つながりを育みます。',
    },
    {
      icon: 'ri-leaf-line',
      title: '持続可能な暮らしと働き方',
      description: '未来世代につながる、調和のとれたライフスタイルを普及します。',
    },
  ];

  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-[1200px] mx-auto px-10">
        {/* セクションタイトル */}
        <div className="text-center mb-16">
          <p className="text-xs font-semibold tracking-widest bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] bg-clip-text text-transparent mb-4">
            ABOUT US
          </p>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2B3C] mb-12">
            一般社団法人 未来ウェルビーイング協会とは
          </h2>
          <p className="text-xl leading-relaxed text-[#3A4A5A] max-w-[800px] mx-auto">
            人と社会のより良いあり方を探求し、こころとからだ、<br />
            社会とのつながり、そしてペットとの共生を軸に、<br />
            調和のとれたウェルビーイングを実現していく協会です。
          </p>
        </div>

        {/* ミッションカード */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-24">
          {missions.map((mission, index) => (
            <div
              key={index}
              className="bg-gradient-to-b from-[#F8FBFF] to-white rounded-[20px] p-10 border border-[#E0EBF5] hover:shadow-xl hover:-translate-y-2 transition-all duration-300"
            >
              <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#4A90E2] to-[#50C9C3] flex items-center justify-center mb-6">
                <i className={`${mission.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-[#1A2B3C] mb-4 leading-snug">
                {mission.title}
              </h3>
              <p className="text-[15px] leading-relaxed text-[#5A6C7D]">
                {mission.description}
              </p>
            </div>
          ))}
        </div>

        {/* 代表理事メッセージ */}
        <div className="grid lg:grid-cols-5 gap-12 items-start">
          {/* 写真 */}
          <div className="lg:col-span-2">
            <div className="aspect-[3/4] w-full h-full rounded-[24px] overflow-hidden shadow-lg">
              <img
                src="https://static.readdy.ai/image/69410fb2e6bcdd872737f1aa8d7dee35/1b6b43a9015a2f64e4913db1c8791009.webp"
                alt="代表理事 森﨑友紀"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* メッセージ */}
          <div className="lg:col-span-3">
            <p className="text-sm font-semibold bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] bg-clip-text text-transparent mb-4">
              代表理事ごあいさつ
            </p>
            <h3 className="text-2xl font-bold text-[#1A2B3C] mb-8 pb-3 border-b-2 border-gradient-to-r from-[#4A90E2] to-[#50C9C3]">
              代表理事　森﨑 友紀
            </h3>
            <div className="space-y-6 text-base leading-loose text-[#3A4A5A]">
              <p>
                私たちは今、大きな時代の転換点に立っています。
              </p>
              <p>
                個人の健康や幸せが、家族、地域、社会全体の豊かさにつながっていく——そんな「しあわせの循環」を、もっと身近に、もっと確かなものにしたい。その想いから、未来ウェルビーイング協会を設立いたしました。
              </p>
              <p>
                人は一人では生きていけません。家族や友人、そして私たちの大切なパートナーであるペットとのつながりの中で、こころもからだも満たされていきます。
              </p>
              <p>
                ボディスキャンによる健康の可視化、LED光美容による新しいケアのかたち、そしてペットとの共生を通じた癒しと学び——これらすべてが、一人ひとりの「ウェルビーイング」を支える土台となります。
              </p>
              <p>
                企業や地域、医療・教育の現場とも手を携えながら、誰もが自分らしく、健やかに、しあわせに生きられる未来を、ともに創っていきたいと願っています。
              </p>
              <p className="font-semibold">
                どうぞよろしくお願いいたします。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
